import { Suspense, useLayoutEffect } from 'react';
import { Route, Routes, useLocation, useNavigationType } from 'react-router-dom';
import { RouterConfig } from './RouterConfig';

export const AppRouter = () => {
    const { pathname } = useLocation();
    const navigationType = useNavigationType();

    // роутер не сбрасывает прокрутку: после ссылки внизу главной новая страница
    // открывалась на той же высоте, а короткая — в самом низу. «Назад» (POP)
    // не трогаем, там браузер возвращает прежнее место. Зависим только от пути:
    // окна входа и регистрации открываются параметрами запроса и страницу не дёргают
    useLayoutEffect(() => {
        if (navigationType !== 'POP') {
            window.scrollTo(0, 0);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [pathname]);

    return (
        <Suspense fallback={<div>Loading</div>}>
            <Routes>
                {RouterConfig &&
                    RouterConfig.map(({ element, path }, id) => (
                        <Route element={element} path={path} key={id}></Route>
                    ))}
            </Routes>
        </Suspense>
    );
};
